<script lang="ts" setup>
import { AisClearRefinements, AisStats } from "vue-instantsearch/vue3/es";
import breakpoints from "#twcss/theme/screens";

const props = defineProps({
  filtersVisible: {
    type: Boolean,
    required: true,
  },
  resultType: {
    type: String,
    required: true,
  },
});

const { t } = useI18n();

// -----------------------
// props & emits
// -----------------------
const emit = defineEmits<{
  (e: "toggle"): void;
}>();

// -----------------------
// refs
// -----------------------
const isListRefined = ref(false);
const hitsNumber = ref(0);

// -----------------------
// computed properties
// -----------------------
const showHitsNumber = computed(() => {
  return props.filtersVisible && isListRefined.value;
});

// -----------------------
// helper methods
// -----------------------
const handleRefinedStatusChange = (value) => {
  isListRefined.value = value;
};

const handleHitsNumberChange = (value) => {
  hitsNumber.value = value;
};

// -----------------------
// vue events
// -----------------------
watch(
  () => props.filtersVisible,
  (visible) => {
    if (visible) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }
  },
);

if (import.meta.client) {
  window.addEventListener("resize", () => {
    // Handling those cases when the user expands the filter overlay on mobile/tablet
    // and rotates its device and the filter overlay disappears due to the wider screen.
    // This must be handled since overflow becomes hidden when filter overlay is
    // visible and if the rule remains intact after the rotate the users cannot scroll.
    if (props.filtersVisible && window.innerWidth >= parseInt(breakpoints.md)) {
      emit("toggle");
    }
  });
}
</script>

<template>
  <BaseButton
    class="filter-button md:hidden bg-brand-search fixed w-[180px] h-[44px] left-1/2 bottom-[50px] ml-[-90px] rounded-30 z-productlistfilterbutton"
    :shadow-outside="true"
    @click="$emit('toggle')"
  >
    <ais-clear-refinements class="hidden">
      <template #default="{ canRefine }">
        {{ handleRefinedStatusChange(canRefine) }}
      </template>
    </ais-clear-refinements>

    <ais-stats class="hidden">
      <template #default="{ nbHits }">
        {{ handleHitsNumberChange(nbHits) }}
      </template>
    </ais-stats>

    <template v-if="showHitsNumber">
      {{ t(resultType, { hits: hitsNumber }) }}
    </template>

    <template v-else>
      <i class="m-icon-filter text-[15px] mr-[5px]"></i>
      {{ t("filter") }}
    </template>
  </BaseButton>
</template>
